import ic_status_done from '@/assets/icons/status/ic_status_done.svg?raw';
import ic_status_error from '@/assets/icons/status/ic_status_error.svg?raw';
import ic_status_info from '@/assets/icons/status/ic_status_info.svg?raw';
import ic_status_warn from '@/assets/icons/status/ic_status_warn.svg?raw';
import { Selection, create, select } from "d3";
import '../../../styles/components/Toast.scss';
import { KeyboardSizeChangeEvent } from "../../types/CustomEvents";
import { _CURRENT_MOBILEKEYBOARD } from '../../utils/Device';
import { _AddSwipeEvent } from '../utils/Swipe';

const DEFALUT_VISIBLE_DURATION = 3000;

const toastTypes = new Map([
    ['success', { iconSVGRaw: ic_status_done }],
    ['error', { iconSVGRaw: ic_status_error }],
    ['warn', { iconSVGRaw: ic_status_warn }],
    ['info', { iconSVGRaw: ic_status_info }],
]);

export type ToastType = 'success' | 'error' | 'warn' | 'info';
export type ToastPosition = 'TOP-LEFT' | 'TOP-RIGHT' | 'BOTTOM-LEFT' | 'BOTTOM-RIGHT';

export function ShowToast(
    title: string, subtitle: string, type?: ToastType, position?: ToastPosition
) {
    CreateToast({ id: type, title: title, subtitle: subtitle, position: position });
}

export function CreateToast(
    opts: { id?: ToastType, title: string, subtitle: string, position?: ToastPosition }
) {
    opts.id = opts.id || 'success'
    opts.position = opts.position || 'TOP-RIGHT'

    let notifications = select<HTMLUListElement, unknown>(".notifications." + opts.position);
    if (notifications.size() == 0) {
        notifications = select("body").append("ul").attr("class", "notifications " + opts.position);
        if (_CURRENT_MOBILEKEYBOARD.BodyTranslateY) {
            notifications.style("top", `calc(var(--padding2) + ${_CURRENT_MOBILEKEYBOARD.BodyTranslateY}px)`);
        }
        document.addEventListener("keyboardsizechange", (ev: KeyboardSizeChangeEvent) => {
            const screenTop = ev.detail.BodyTranslateY;
            if (screenTop == 0) {
                notifications.style("top", null);
            } else {
                notifications.style("top", `calc(var(--padding2) + ${screenTop}px)`);
            }
        })
    }

    const { iconSVGRaw } = toastTypes.get(opts.id) || { iconSVGRaw: '', title: '', message: "" };

    const toast = create("li");
    toast.classed('toast ' + opts.id, true);
    toast.html(`<div class="column">
                    <div class="icon-toast">...</div>
                    <div class="row">
                        <span>${opts.title}</span>
                        <span class="subtitle">${opts.subtitle}</span>
                    </div>
                </div>`);
    toast.select(".icon-toast").html(iconSVGRaw);
    _AddSwipeEvent(toast.node(), "swipeRight", () => RemoveToast(toast));
    toast.property("timeoutId", setTimeout(() => RemoveToast(toast), DEFALUT_VISIBLE_DURATION));

    notifications.node().insertAdjacentElement("afterbegin", toast.node());
}

export function RemoveToast(toast: Selection<HTMLLIElement, any, any, any>) {
    toast.classed("hides", true);
    if (toast.property("timeoutId")) clearTimeout(toast.property("timeoutId"))
    setTimeout(() => toast.remove(), 200);
}